console.log("TeamFilters: Initializing team filters component");

var winWidth = $(window).width();
console.log("TeamFilters: Window width detected:", winWidth);

if ($(".team--item").length > 0) {
  console.log("TeamFilters: Found team items, setting up modal interactions");

  $("body").on("click", ".team--item-link", function (e) {
    try {
      console.log("TeamFilters: Team item link clicked");
      e.preventDefault();
      var href = $(this).attr("href");
      console.log("TeamFilters: Modal href:", href);

      $(".team-item--modal").removeClass("is-showing");
      $(href).addClass("is-showing");
      console.log("TeamFilters: Modal opened successfully");
    } catch (error) {
      console.error(
        "TeamFilters: Error in team item link click handler:",
        error
      );
    }
  });

  $("body").on("click", ".team-item--modal", function () {
    try {
      console.log("TeamFilters: Team modal clicked");
      var modalID = $(this).attr("id");
      console.log("TeamFilters: Modal ID:", modalID);

      $(".team-item--modal").removeClass("is-showing");
      $(modalID).addClass("is-showing");
      console.log("TeamFilters: Modal state updated");
    } catch (error) {
      console.error("TeamFilters: Error in team modal click handler:", error);
    }
  });

  $("body").on("click", ".team-item--modal", function () {
    try {
      console.log("TeamFilters: Team modal close clicked");
      $(this).removeClass("is-showing");
      console.log("TeamFilters: Modal closed successfully");
    } catch (error) {
      console.error("TeamFilters: Error in team modal close handler:", error);
    }
  });
} else {
  console.log("TeamFilters: No team items found, skipping modal setup");
}

if ($(".team--select").length > 0) {
  console.log(
    "TeamFilters: Found team select elements, setting up change handlers"
  );

  if (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0 ||
    window.document.documentMode
  ) {
    console.log(
      "TeamFilters: Touch device detected, using basic change handler"
    );

    $(".team--select").on("change", function (e) {
      try {
        console.log("TeamFilters: Select changed on touch device");
        updateTeamGrid();
        e.preventDefault();
        console.log("TeamFilters: Team grid updated successfully");
      } catch (error) {
        console.error(
          "TeamFilters: Error in touch device select change handler:",
          error
        );
      }
    });
  } else {
    console.log("TeamFilters: Desktop device detected, using selectric plugin");

    $(".team--select")
      .on("change", function (e) {
        try {
          console.log("TeamFilters: Select changed on desktop");
          e.preventDefault();
          updateTeamGrid();
          console.log("TeamFilters: Team grid updated successfully");
        } catch (error) {
          console.error(
            "TeamFilters: Error in desktop select change handler:",
            error
          );
        }
      })
      .selectric({
        maxHeight: 300,
        disableOnMobile: true,
      });

    console.log("TeamFilters: Selectric plugin initialized");
  }
} else {
  console.log("TeamFilters: No team select elements found");
}

// Client-side dataset cache from localized object
var __teamDataset =
  typeof localized_object !== "undefined" && localized_object.team_dataset
    ? localized_object.team_dataset
    : null;

function ensureDataset(callback) {
  if (__teamDataset && Array.isArray(__teamDataset.items)) {
    callback(__teamDataset);
    return;
  }
  console.error("TeamFilters: Embedded team dataset missing");
}

function renderTeam(items, ctx) {
  var grid = $(".team--grid");
  var modalsRoot = $(".team-modals");
  if (grid.length === 0) return;

  function itemHtml(it, index, total) {
    var itemClasses = "";

    ["roles", "titles", "business_units", "locations"].forEach(function (key) {
      if (Array.isArray(it[key])) {
        it[key].forEach(function (t) {
          itemClasses += " " + t.slug;
        });
      }
    });

    var locationSmall = "";
    if (Array.isArray(it.location_names) && it.location_names.length) {
      locationSmall = "<small>" + it.location_names.join(", ") + "</small>";
    }

    if (!it.is_senior) {
      itemClasses += " has-no-image";
      itemClasses +=
        index % 2 === 0 ? " all-leadership-even" : " all-leadership-odd";
      if (index === total - 1) itemClasses += " is-last-item";
    }

    var itemId = it.slug;
    var name = it.name || "";
    var titleArchive = it.title_archive_page
      ? "<small>" + it.title_archive_page + "</small>"
      : "";

    var item =
      '<div id="' +
      itemId +
      '" class="team--item ' +
      itemClasses +
      '" data-searchtags="' +
      it.search_tags +
      '">';
    item += '<div class="team--item-inner">';

    if (it.is_senior && it.image) {
      item +=
        '<a href="#team-item--modal-' +
        it.slug +
        '" class="team--item-link" aria-label="' +
        name +
        '"></a>';
      item += '<div class="team--item-image">';
      item += '<div style="background-image:url(' + it.image + ')"></div>';
      item += "</div>";
    }

    item += '<div class="team--item-content">';
    item += "<h4>" + name + titleArchive + locationSmall + "</h4>";
    item += "</div>";

    item += "</div>";
    item += "</div>";
    return item;
  }

  function modalHtml(it) {
    var name = it.name || "";
    var titleArchive = it.title_archive_page
      ? "<small>" + it.title_archive_page + "</small>"
      : "";
    var modal =
      '<div id="team-item--modal-' + it.slug + '" class="team-item--modal">';
    modal += '<div class="team-item--modal--content">';
    modal += '<div class="team-item--modal--close">&times;</div>';
    modal +=
      '<h4 class="team-item--modal--title">' + name + titleArchive + "</h4>";
    modal += it.content || "";
    modal += "</div>";
    modal += "</div>";
    return modal;
  }

  function groupKeyForItem(it, filtersEmpty) {
    var hasDefault = (it.roles || []).some(function (r) {
      return r.slug === "default-leadership";
    });
    var hasSenior = (it.roles || []).some(function (r) {
      return r.slug === "senior-leadership";
    });
    if (filtersEmpty && hasDefault) return "default-leadership";
    if (hasSenior) return "senior-leadership";
    return "all-leadership";
  }

  function sortByTeamTitleOrder(list) {
    var orderMap =
      typeof localized_object !== "undefined" &&
      localized_object.team_titles_order
        ? localized_object.team_titles_order
        : null;
    if (!orderMap) return list;

    return list.slice().sort(function (a, b) {
      var at = a.titles && a.titles.length ? a.titles[0].slug : null;
      var bt = b.titles && b.titles.length ? b.titles[0].slug : null;

      var ai = at && at in orderMap ? orderMap[at] : Number.MAX_SAFE_INTEGER;
      var bi = bt && bt in orderMap ? orderMap[bt] : Number.MAX_SAFE_INTEGER;

      if (ai !== bi) return ai - bi;
      // fallback by last_name (asc)
      var an = (a.last_name || "").toLowerCase();
      var bn = (b.last_name || "").toLowerCase();
      if (an < bn) return -1;
      if (an > bn) return 1;
      return 0;
    });
  }

  var html = "";
  var modalsHtml = "";
  var filtersEmpty = ctx && ctx.filtersEmpty;
  var titleVal = ctx && ctx.titleVal;
  var businessVal = ctx && ctx.businessVal;
  var locationVal = ctx && ctx.locationVal;

  // Business child grouping when business is selected, title/location empty
  var shouldGroupByBU = !!businessVal && !titleVal && !locationVal;
  var hasChildBU =
    shouldGroupByBU &&
    (items || []).some(function (it) {
      return (it.business_units || []).some(function (b) {
        return b.parent && b.parent !== 0;
      });
    });

  var ORDER_ROLE = [
    "default-leadership",
    "senior-leadership",
    "all-leadership",
  ];

  if (shouldGroupByBU && hasChildBU) {
    // Build BU -> role groups
    var buMap = {};
    items.forEach(function (it) {
      var child = (it.business_units || []).find(function (b) {
        return b.parent && b.parent !== 0;
      });
      if (!child) return;
      var buKey = child.name;
      if (!buMap[buKey])
        buMap[buKey] = {
          "default-leadership": [],
          "senior-leadership": [],
          "all-leadership": [],
        };
      var key = groupKeyForItem(it, filtersEmpty);
      buMap[buKey][key].push(it);
    });

    // Optional special ordering for governance-risk-compliance-it
    var buKeys = Object.keys(buMap);
    if (businessVal === "governance-risk-compliance-it") {
      var desired = ["Governance", "Risk", "Compliance", "IT"];
      buKeys.sort(function (a, b) {
        var ia = desired.indexOf(a);
        var ib = desired.indexOf(b);
        if (ia === -1 && ib === -1) return a.localeCompare(b);
        if (ia === -1) return 1;
        if (ib === -1) return -1;
        return ia - ib;
      });
    }

    var globalIndex = 0;
    buKeys.forEach(function (buKey) {
      html += '<h2 class="team--subheading h3">' + buKey + "</h2>";
      ORDER_ROLE.forEach(function (roleKey) {
        var list = sortByTeamTitleOrder(buMap[buKey][roleKey]);
        if (!list || !list.length) return;
        list.forEach(function (it, idx) {
          html += itemHtml(it, globalIndex + idx, list.length);
          modalsHtml += modalHtml(it);
        });
        globalIndex += list.length;
        if (roleKey !== "all-leadership") {
          html += '<div class="team--item--divider"></div>';
        }
      });
    });
  } else {
    // Simple role groups
    var roleGroups = {
      "default-leadership": [],
      "senior-leadership": [],
      "all-leadership": [],
    };
    items.forEach(function (it) {
      roleGroups[groupKeyForItem(it, filtersEmpty)].push(it);
    });

    var runningIndex = 0;
    ORDER_ROLE.forEach(function (roleKey) {
      var list = sortByTeamTitleOrder(roleGroups[roleKey]);
      if (!list || !list.length) return;
      list.forEach(function (it, idx) {
        html += itemHtml(it, runningIndex + idx, list.length);
        modalsHtml += modalHtml(it);
      });
      runningIndex += list.length;
      if (roleKey !== "all-leadership") {
        html += '<div class="team--item--divider"></div>';
      }
    });
  }

  grid.html(html);
  if (modalsRoot.length) modalsRoot.html(modalsHtml);
}

function filterDataset(dataset, opts) {
  var title = opts.title || "";
  var business = opts.business || "";
  var location = opts.location || "";
  var search = (opts.search || "").toLowerCase();

  var filtered = dataset.items || [];

  // Default state: Leadership (default-leadership only) when no filters/search
  if (!title && !business && !location && !search) {
    filtered = filtered.filter(function (it) {
      var roles = it.roles || [];
      for (var i = 0; i < roles.length; i++) {
        if (roles[i].slug === "default-leadership") return true;
      }
      return false;
    });
    return filtered;
  }

  if (title) {
    filtered = filtered.filter(function (it) {
      return (it.titles || []).some(function (t) {
        return t.slug === title;
      });
    });
  }

  if (business) {
    filtered = filtered.filter(function (it) {
      return (it.business_units || []).some(function (t) {
        return t.slug === business;
      });
    });
  }

  if (location) {
    filtered = filtered.filter(function (it) {
      return (it.locations || []).some(function (t) {
        return t.slug === location;
      });
    });
  }

  if (search) {
    filtered = filtered.filter(function (it) {
      return (
        (it.search_tags || "").toLowerCase().indexOf(search) !== -1 ||
        (it.name || "").toLowerCase().indexOf(search) !== -1 ||
        (it.title_archive_page || "").toLowerCase().indexOf(search) !== -1
      );
    });
  }

  return filtered;
}

var updateTeamGrid = function () {
  try {
    var grid = $(".team--grid");
    var filterVals = "";

    if (grid.length === 0) return;

    var searchVal = $("#team--search__input").val();
    var title = $("#team-filter--title");
    var titleVal = title.val();
    var business = $("#team-filter--business-unit");
    var businessVal = business.val();
    var location = $("#team-filter--location");
    var locationVal = location.val();

    if (titleVal)
      filterVals += "<span>" + title.find(":selected").text() + "</span>";
    if (businessVal)
      filterVals += "<span>" + business.find(":selected").text() + "</span>";
    if (locationVal)
      filterVals += "<span>" + location.find(":selected").text() + "</span>";
    $(".team--heading").html(filterVals || "Leadership");

    grid.addClass("is-loading");

    ensureDataset(function (dataset) {
      var filtered = filterDataset(dataset, {
        title: titleVal,
        business: businessVal,
        location: locationVal,
        search: searchVal,
      });
      renderTeam(filtered, {
        filtersEmpty: !titleVal && !businessVal && !locationVal,
        titleVal: titleVal,
        businessVal: businessVal,
        locationVal: locationVal,
      });
      grid.removeClass("is-loading");
    });
  } catch (e) {
    console.error("TeamFilters: updateTeamGrid error", e);
  }
};

// Override reset behavior to default to Leadership view
$("#team--search__reset")
  .off("click")
  .on("click", function (e) {
    try {
      console.log(
        "TeamFilters: Search reset button clicked (leadership default)"
      );
      e.preventDefault();

      $(".team--select").val("").selectric("refresh");
      $("#team--search__input").val("");
      $(".team--grid").removeClass("is-searching");

      var grid = $(".team--grid");
      grid.addClass("is-loading");
      $(".team--heading").html("Leadership");

      ensureDataset(function (dataset) {
        var leadership = (dataset.items || []).filter(function (it) {
          var roles = it.roles || [];
          for (var i = 0; i < roles.length; i++) {
            if (roles[i].slug === "default-leadership") {
              return true;
            }
          }
          return false;
        });
        renderTeam(leadership, { filtersEmpty: true });
        grid.removeClass("is-loading");
      });
    } catch (error) {
      console.error("TeamFilters: Error in leadership reset handler:", error);
    }
  });

$("#team--search__button").on("click", function (e) {
  try {
    console.log("TeamFilters: Search button clicked");
    e.preventDefault();
    updateTeamGrid();
    console.log("TeamFilters: Team grid updated after search");
  } catch (error) {
    console.error("TeamFilters: Error in search button handler:", error);
  }
});

$("#team--search__input")
  .off("keyup")
  .on("keyup", function (event) {
    var val = $(this).val();
    console.log("TeamFilters: Search input value:", val);

    if (val.length > 2) {
      updateTeamGrid();
    } else if (val.length === 0) {
      $(".team--grid").removeClass("is-searching");
      updateTeamGrid();
    }
  });

function searchTeam(value) {
  try {
    console.log("TeamFilters: searchTeam function called with value:", value);

    var tagValue = value.replace(/[^a-z0-9]/gi, "-");
    tagValue = tagValue.replace("--", "-");
    console.log("TeamFilters: Processed tag value:", tagValue);

    var teamItems = $(".team--grid").find(".team--item");
    console.log("TeamFilters: Found team items for search:", teamItems.length);

    if (tagValue && tagValue.length > 2) {
      console.log("TeamFilters: Search value is valid, starting search");
      $(".team--grid").addClass("is-searching");

      teamItems.each(function (index) {
        try {
          var shouldHide = false;
          var teamItem = $(this);
          var tags = teamItem.data("searchtags");

          console.log(
            "TeamFilters: Processing item",
            index,
            "with tags:",
            tags
          );

          if (!tags.includes(tagValue)) {
            shouldHide = true;
            console.log("TeamFilters: Item", index, "should be hidden");
          } else {
            console.log("TeamFilters: Item", index, "matches search");
          }

          if (shouldHide) {
            $(this).addClass("is-hiding");
          } else {
            $(this).removeClass("is-hiding").addClass("over");
          }
        } catch (itemError) {
          console.error(
            "TeamFilters: Error processing team item",
            index,
            ":",
            itemError
          );
        }
      });

      console.log("TeamFilters: Search completed");
    } else {
      console.log(
        "TeamFilters: Search value too short or empty, clearing search"
      );
      teamItems.removeClass("is-hiding");
      $(".team--grid").removeClass("is-searching");
    }
  } catch (error) {
    console.error("TeamFilters: Error in searchTeam function:", error);
  }
}

// Initial render on page load using dataset and default filters
$(function () {
  try {
    updateTeamGrid();
  } catch (e) {
    console.error("TeamFilters: initial render failed", e);
  }
});
